import React, { useState } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { useAuth } from '../auth/AuthProvider';
import { courseModules } from '../data/courseModules';
import Modal from './Modal';
import VideoPlayer from './VideoPlayer';
import LanguageSelector from './LanguageSelector';

export default function SideDrawer({ open, onClose }) {
  const { isAuthenticated, user, signOut } = useAuth();
  const nav = useNavigate();
  const loc = useLocation();
  const [modulesExpanded, setModulesExpanded] = useState(true);
  const [isVideoPlayerOpen, setIsVideoPlayerOpen] = useState(false);
  const disableMenu = loc.pathname ===  '/registration-success' || loc.pathname ===  '/registration';
  

  const go = (path) => {
    nav(path);
    onClose();
  };

  const isActive = (path) => loc.pathname === path || loc.pathname.startsWith(path + '/');

  const getUserDisplayName = () => {
    if (user?.attributes?.name) {
      return user.attributes.name;
    }
    if (user?.name) {
      return user.name;
    }
    return "User";
  };

  return (
    <>
      <div className={`drawer-backdrop ${open ? 'show' : ''}`} onClick={onClose} />
      <aside className={`drawer ${open ? 'open' : ''}`}>
        <div className="drawer-header">
          <div className="drawer-title">Sai Sruti</div>
          
          <button className="drawer-close" onClick={onClose}>✕</button>
         
        </div>
         <LanguageSelector />
        {isAuthenticated ? (
          <>
            <div className="drawer-user-info">
              <span className="drawer-user-label">Logged in as:</span>
              <div className="drawer-username">{getUserDisplayName()}</div>
              <button className="drawer-link" onClick={() => go('/profile')}>Update Profile</button>
              <button className="drawer-link" onClick={async () => { await signOut(); go('/'); }}>Sign out</button>
            </div>
            <nav className="drawer-nav">
              {/* <button className={`drawer-link ${isActive('/home') ? 'active' : ''}`} onClick={() => go('/home')}>Home</button>
              <button className="drawer-link" onClick={() => { setIsVideoPlayerOpen(true); onClose(); }}>Video</button> */}
            {!disableMenu &&    <div className="drawer-section">
                <button className="drawer-link section-head" onClick={() => setModulesExpanded(!modulesExpanded)}>
                  Modules
                  <span style={{ marginLeft: 'auto' }}>{modulesExpanded ? '▲' : '▼'}</span>
                </button>
                {modulesExpanded && (
                  <div className="drawer-section drawer-sub">
                    {courseModules.map((module) => {
                      const moduleNumber = module.id.split('-')[1];
                      const path = `/module/${moduleNumber}`;
                      return (
                        <button
                          key={module.id}
                          className={`drawer-link ${isActive(path) ? 'active' : ''}`}
                          onClick={() => go(path)}
                        >
                          {module.title}
                        </button>
                      );
                    })}
                  </div>
                )}
              </div>}
            </nav>
          </>
        ) : (
          <nav className="drawer-nav">
            <button className="drawer-link" onClick={() => go('/login')}>Login</button>
          </nav>
        )}
        </aside>
        {isVideoPlayerOpen && (
          <Modal title="Sample Video" onClose={() => setIsVideoPlayerOpen(false)}>
            <VideoPlayer videoId="tLZSe2bfNsI" />
          </Modal>
        )}
    </>
  );
}